import React, { useState } from 'react';
import { TextInput,Button,RadioGroup, Radio,Container,NumberInput, LoadingOverlay  } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useForm } from '@mantine/hooks';
import './Register.scss';

import { EnvelopeClosedIcon } from '@radix-ui/react-icons'
export const Register: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [nrCertificatHandicap, setNrCertificatHandicap] = useState('');
    const [durataCertificatHandicap, setDurataCertificatHandicap] = useState(1);

    const form = useForm({
        initialValues: {
            firstName: '',
            lastName: '',
            email: '',
            nrCertificatHandicap: '',
            durataCertificatHandicap:1
        },

        validationRules: {
            firstName: (value) => value.trim().length >= 2,
            lastName: (value) => value.trim().length >= 2,
            email: (value) => /^\S+@\S+$/.test(value),
            nrCertificatHandicap: (value) => value.trim().length >= 2,
            durataCertificatHandicap: (value) => value >= 0
        },
    });

    const handleSubmit = (values: typeof form['values']) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            if (values.email === 'test@mantine.dev') {
                form.setFieldError('email', true);
            }
        }, 1500);
    };

const matchesDesktop = useMediaQuery('(min-width: 768px)');
return <div>
    <form onSubmit={form.onSubmit(handleSubmit)} >
    <LoadingOverlay visible={loading} />
    <Container size="xs" padding="xs">
    <RadioGroup
        className="form__group--tip__persoana"
        label="Indicati calitatea dvs."
        description=""
        required
        variant={matchesDesktop ? 'horizontal' : 'vertical'}
    >
        <Radio value="ph">Persoana cu handicap</Radio>
        <Radio value="i">Insotitor</Radio>
        <Radio value="ap">Asistent personal</Radio>
    </RadioGroup>
    </Container>

    <div className="form__container">


            <TextInput
                className="form__element"
                aria-label="Numele de familie"
                placeholder="Numele de familie"
                required
                label="Numele de familie"
                error={form.errors.lastName && 'completati numele de familie'}
                value={form.values.lastName}
                onChange={(event) => form.setFieldValue('lastName', event.currentTarget.value)}
            />
            <TextInput
                className="form__element"
                aria-label="Prenumele"
                placeholder="Prenumele"
                required
                label="Prenumele"
                error={form.errors.firstName && 'completati prenumele'}
                value={form.values.firstName}
                onChange={(event) => form.setFieldValue('firstName', event.currentTarget.value)}
            />
            <TextInput
                className="form__element"
                aria-label="Adresa dvs. de email"
                icon={<EnvelopeClosedIcon />}
                placeholder="Adresa dvs. de email"
                required
                label="Adresa email"
                error={form.errors.email && 'completati adresa de email'}
                value={form.values.email}
                onChange={(event) => form.setFieldValue('email', event.currentTarget.value)}
            />
            <TextInput
                className="form__element"
                aria-label="Numar certificat incadrare in handicap"
                placeholder="Numar certificat incadrare in handicap"
                required
                label="Numar certificat incadrare handicap"
                error={form.errors.nrCertificatHandicap && 'completati nr. certificatului'}
                value={form.values.nrCertificatHandicap}
                onChange={(event) => form.setFieldValue('nrCertificatHandicap', event.currentTarget.value)}
            />
            <NumberInput
                className="form__element"
                aria-label="Durata certificatului in luni"
                placeholder="Durata certificatului in luni"
                required
                label="Durata certificatului in luni"
                error={form.errors.durataCertificatHandicap && 'completati durata in luni'}
                value={form.values.durataCertificatHandicap}
                onChange={(val) => form.setFieldValue('durataCertificatHandicap', val)}
            />

        </div>

    <div style={{ display: 'flex', justifyContent: 'center' }}>
        <Button type="submit" style={{ width: 200, marginTop: 10 }}>Inscriere!</Button>
    </div>

</form>
    </div>;
}
